import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { STATE__generation } from './STATE__generation';

export const LOCAL__generation_set_generation_id_next = (payload: string): PayloadAction<string> => ({
  type: ENUM__redux_action.GENERATION_SET_NEXT,
  payload,
});

export function INIT_LOCAL__generation_set_generation_id_next(state: STATE__generation, action: PayloadAction<string>) {
  state.generation_next_id = action.payload;
}
